import { LiquidityFacilityOverviewTable } from './liquidityFacilityOverviewTable';

export default LiquidityFacilityOverviewTable;